module.exports = __webpack_public_path__ + "media/images/evgeny-722be1ddda8bd0da6bd7337a735f29a6.png";